import TabListProvider from './hooks/useTabList';

import { TabListProps } from './@types/TabListProps';
import TabListContainer from './handles/TabListContainer';

const TabList = (props: TabListProps) => (
	<TabListProvider {...props}>
		<TabListContainer>{props.children}</TabListContainer>
	</TabListProvider>
);

export default TabList;
